import { ShortMetadata } from '../types';

export const getShortMetadataForDashboard = (
  shortMetadata: ShortMetadata,
): string => {
  return JSON.stringify(shortMetadata);
};
